import { createApiAction } from 'src/api';

/* people */

export const FETCH_PEOPLE_START = 'account/fetch_people_start';
export const FETCH_PEOPLE_SUCCESS = 'account/fetch_people_success';
export const FETCH_PEOPLE_FAILURE = 'account/fetch_people_failure';

export const ADD_PERSON_START = 'account/add_person_start';
export const ADD_PERSON_SUCCESS = 'account/add_person_success';
export const ADD_PERSON_FAILURE = 'account/add_person_failure';

export const UPDATE_PERSON_START = 'account/update_person_start';
export const UPDATE_PERSON_SUCCESS = 'account/update_person_success';
export const UPDATE_PERSON_FAILURE = 'account/update_person_failure';

export const DELETE_PERSON_START = 'account/delete_person_start';
export const DELETE_PERSON_SUCCESS = 'account/delete_person_success';
export const DELETE_PERSON_FAILURE = 'account/delete_person_failure';

export const ADD_PERSON_BADGE_START = 'account/add_person_badge_start';
export const ADD_PERSON_BADGE_SUCCESS = 'account/add_person_badge_success';
export const ADD_PERSON_BADGE_FAILURE = 'account/add_person_badge_failure';

export const SET_PERSON_LICENSE_IMAGES_START =
  'account/set_person_license_images_start';
export const SET_PERSON_LICENSE_IMAGES_SUCCESS =
  'account/set_person_license_images_success';
export const SET_PERSON_LICENSE_IMAGES_FAILURE =
  'account/set_person_license_images_failure';

/* badges */

export const UPDATE_PERSON_BADGE_START = 'account/update_person_badge_start';
export const UPDATE_PERSON_BADGE_SUCCESS =
  'account/update_person_badge_success';
export const UPDATE_PERSON_BADGE_FAILURE =
  'account/update_person_badge_failure';

export const SET_PERSON_BADGE_IMAGES_START =
  'account/set_person_badge_image_start';
export const SET_PERSON_BADGE_IMAGES_SUCCESS =
  'account/set_person_badge_image_success';
export const SET_PERSON_BADGE_IMAGES_FAILURE =
  'account/set_person_badge_image_failure';

export const DELETE_PERSON_BADGE_START = 'account/delete_person_badge_start';
export const DELETE_PERSON_BADGE_SUCCESS =
  'account/delete_person_badge_success';
export const DELETE_PERSON_BADGE_FAILURE =
  'account/delete_person_badge_failure';
export const UPDATE_ACCOUNT_AGENTS_SUCCESS =
  'account/update_account_agents_success';
export const UPDATE_ACCOUNT_AGENTS_FAILURE =
  'account/update_account_agents_failure';
export const UPDATE_ACCOUNT_AGENTS_START =
  'account/update_account_agents_start';
export const FETCH_ACCOUNT_AGENTS_START = 'account/fetch_account_agents_start';
export const FETCH_ACCOUNT_AGENTS_SUCCESS =
  'account/fetch_account_agents_success';
export const FETCH_ACCOUNT_AGENTS_FAILURE =
  'account/fetch_account_agents_failure';
/* people */
/* people */

export const fetchAccountPeople = ({ accountId }) =>
  createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/users/`,
      method: 'GET',
    },
    [FETCH_PEOPLE_START, FETCH_PEOPLE_SUCCESS, FETCH_PEOPLE_FAILURE]
  );

export const addAccountPerson = ({
  accountId,
  financialInstitutionId,
  emailAddress,
  firstName,
  lastName,
  type,
  primaryNumber,
  isAdmin,
  isSigner,
  sendEmail,
  message,
  insuranceGroupName,
}) =>
  createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/users/`,
      method: 'POST',
      body: {
        user_financial_institution_id: financialInstitutionId,
        user_type: type,
        user_first_name: firstName,
        user_last_name: lastName,
        user_primary_number: primaryNumber,
        user_email_address: emailAddress,
        user_is_admin: isAdmin,
        user_is_signer: isSigner,
        insurance_information_group_name: insuranceGroupName
          ? {
              insurance_group_name: insuranceGroupName.label,
              id: insuranceGroupName.value,
            }
          : null,
        send_email: !!sendEmail,
        message,
      },
    },
    [ADD_PERSON_START, ADD_PERSON_SUCCESS, ADD_PERSON_FAILURE]
  );

export const updateAccountPerson = ({
  accountId,
  financialInstitutionId,
  personId,
  emailAddress,
  firstName,
  lastName,
  citizenship,
  dob,
  flag,
  isAdmin,
  isSigner,
  licenseTypeId,
  licenseExpirationDate,
  licenseIssuedDate,
  licenseIssuingState,
  licenseNumber,
  mailingAddress,
  mailingAddress2,
  mailingCity,
  mailingState,
  mailingZipcode,
  military,
  occupation,
  otherNumber,
  percentageOwnership,
  primaryAddress,
  primaryAddress2,
  primaryCity,
  primaryNumber,
  primaryState,
  primaryZipcode,
  socialSecurity,
  coverage,
  gender,
  familyMembers,
  title,
  type,
  allowedReports,
  insuranceGroupName,
  insuranceInformationMarkedComplete,
  user_license_image_front,
  user_license_image_back,
}) =>
  createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/users/${personId}/`,
      method: 'PUT',
      body: {
        user_type: type,
        user_financial_institution_id: financialInstitutionId,
        user_first_name: firstName,
        user_last_name: lastName,
        user_primary_number: primaryNumber,
        user_other_number: otherNumber,
        user_email_address: emailAddress,
        user_primary_address: primaryAddress,
        user_primary_address_2: primaryAddress2,
        user_primary_city: primaryCity,
        user_primary_state: primaryState,
        user_primary_zipcode: primaryZipcode,
        user_mailing_address: mailingAddress,
        user_mailing_address_2: mailingAddress2,
        user_mailing_city: mailingCity,
        user_mailing_state: mailingState,
        user_mailing_zipcode: mailingZipcode,
        user_ssn: socialSecurity,
        _user_social_security_enc: socialSecurity,
        user_dob: dob,
        user_license_type: licenseTypeId,
        user_license_number: licenseNumber,
        user_license_issuing_state: licenseIssuingState,
        user_license_issued_date: licenseIssuedDate,
        user_license_expiration_date: licenseExpirationDate,
        user_occupation: occupation,
        user_military: military,
        user_gender: gender,
        user_citizenship: citizenship,
        user_flag: flag,
        ...(user_license_image_front !== undefined && { user_license_image_front }),
        ...(user_license_image_back !== undefined && { user_license_image_back }),
        user_user_account: {
          user_account_is_admin: isAdmin,
          user_account_is_signer: isSigner,
          user_account_percentage_ownership: percentageOwnership,
          user_account_title: title,
          user_account_allowed_reports: allowedReports,
        },
        user_insurance_information: coverage
          ? {
              insurance_information_coverage_type: coverage,
              insurance_information_family_member: familyMembers,
              insurance_information_marked_complete: insuranceInformationMarkedComplete,
              insurance_information_group_name: insuranceGroupName
                ? {
                    insurance_group_name: insuranceGroupName.label,
                    insurance_group_name_id: insuranceGroupName.value,
                  }
                : null,
            }
          : null,
      },
    },
    [UPDATE_PERSON_START, UPDATE_PERSON_SUCCESS, UPDATE_PERSON_FAILURE]
  );

export const deleteAccountPerson = ({ accountId, personId }) => {
  return createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/users/${personId}/`,
      method: 'DELETE',
    },
    [DELETE_PERSON_START, DELETE_PERSON_SUCCESS, DELETE_PERSON_FAILURE]
  );
};

export const updateAccountPersonStatus = ({ accountId, personId, statusId }) =>
  createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/users/${personId}/`,
      method: 'PATCH',
      body: {
        user_user_account: {
          user_account_status: statusId,
        },
      },
    },
    [UPDATE_PERSON_START, UPDATE_PERSON_SUCCESS, UPDATE_PERSON_FAILURE]
  );

/* badges */

export const addAccountPersonBadge = ({
  accountId,
  personId,
  locationId,
  badgeNumber,
  badgeDateExpired,
}) =>
  createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/users/${personId}/badges/`,
      method: 'POST',
      body: {
        badge_location: locationId,
        badge_number: badgeNumber,
        badge_date_expired: badgeDateExpired,
      },
    },
    [ADD_PERSON_BADGE_START, ADD_PERSON_BADGE_SUCCESS, ADD_PERSON_BADGE_FAILURE]
  );

export const updateAccountPersonBadge = ({
  accountId,
  personId,
  badgeId,
  locationId,
  badgeNumber,
  badgeDateExpired,
}) =>
  createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/users/${personId}/badges/${badgeId}`,
      method: 'PUT',
      body: {
        badge_location: locationId,
        badge_number: badgeNumber,
        badge_date_expired: badgeDateExpired,
      },
    },
    [
      UPDATE_PERSON_BADGE_START,
      UPDATE_PERSON_BADGE_SUCCESS,
      UPDATE_PERSON_BADGE_FAILURE,
    ]
  );

export const setAccountPersonBadgeImages = ({
  accountId,
  personId,
  badgeId,
  imageFront,
  imageBack,
}) => {
  const formData = new FormData();
  if (imageFront) {
    formData.append('badge_image_front', imageFront);
  }

  if (imageBack) {
    formData.append('badge_image_back', imageBack);
  }

  return createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/users/${personId}/badges/${badgeId}/badge_images/`,
      method: 'POST',
      formData,
    },
    [
      SET_PERSON_BADGE_IMAGES_START,
      SET_PERSON_BADGE_IMAGES_SUCCESS,
      SET_PERSON_BADGE_IMAGES_FAILURE,
    ]
  );
};

export const deleteAccountPersonBadge = ({ accountId, personId, badgeId }) => {
  return createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/users/${personId}/badges/${badgeId}`,
      method: 'DELETE',
    },
    [
      DELETE_PERSON_BADGE_START,
      DELETE_PERSON_BADGE_SUCCESS,
      DELETE_PERSON_BADGE_FAILURE,
    ]
  );
};

/* license */

export const setAccountPersonLicenseImages = ({
  accountId,
  personId,
  imageFront,
  imageBack,
}) => {
  const formData = new FormData();

  if (imageFront) {
    formData.append('user_license_image_front', imageFront);
  }

  if (imageBack) {
    formData.append('user_license_image_back', imageBack);
  }

  return createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/users/${personId}/license_images/`,
      method: 'POST',
      formData,
    },
    [
      SET_PERSON_LICENSE_IMAGES_START,
      SET_PERSON_LICENSE_IMAGES_SUCCESS,
      SET_PERSON_LICENSE_IMAGES_FAILURE,
    ]
  );
};

// Account Agents
export const updateAccountAgents = ({
  financialInstitutionId,
  accountId,
  addPrimary,
  addSecondary,
  deletePrimary,
  deleteSecondary,
}) => {
  return createApiAction(
    {
      path: `/api/v1/fis/${financialInstitutionId}/agents/${accountId}`,
      method: 'PUT',
      body: {
        primary_agents_add: addPrimary,
        secondary_agents_add: addSecondary,
        primary_agents_delete: deletePrimary,
        secondary_agents_delete: deleteSecondary,
      },
    },
    [
      UPDATE_ACCOUNT_AGENTS_START,
      UPDATE_ACCOUNT_AGENTS_FAILURE,
      UPDATE_ACCOUNT_AGENTS_SUCCESS,
    ]
  );
};

export const fetchAccountAgents = ({ accountId, financialInstitutionId }) => {
  return createApiAction(
    {
      path: `/api/v1/fis/${financialInstitutionId}/agents/${accountId}`,
      method: 'GET',
    },
    [
      FETCH_ACCOUNT_AGENTS_START,
      FETCH_ACCOUNT_AGENTS_FAILURE,
      FETCH_ACCOUNT_AGENTS_SUCCESS,
    ]
  );
};
